function BoostIcon() {
	return (
		<svg
			width="81"
			height="81"
			viewBox="0 0 81 81"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.5"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M47.0889 0.710201C58.9437 3.51588 59.6788 19.9269 66.3573 30.1153C70.7348 36.7933 77.6643 41.5105 78.9947 49.3838C80.584 58.7889 81.2491 70.0695 74.1934 76.4882C67.2284 82.8244 56.4397 79.5137 47.0889 78.409C39.2758 77.486 32.3963 74.9099 25.712 70.7606C15.9424 64.696 2.4456 60.6866 0.330918 49.3838C-1.8913 37.5061 7.50086 26.8812 15.8721 18.167C24.4582 9.22913 35.0283 -2.14419 47.0889 0.710201Z"
				fill="#C8E4FF"
			/>
			<path
				d="M39.0367 21.0266L29.6738 40.9961L20.8484 49.8215C19.3839 51.286 19.3839 53.6604 20.8484 55.1249L23.5001 57.7766C24.9645 59.2411 27.3389 59.2411 28.8034 57.7766L37.6288 48.9512L57.5983 39.5883"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M60.2497 42.2398L36.3848 18.375"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.5"
				d="M56.4336 27.8167L60.2502 25.875"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.5"
				d="M50.8086 22.1917L52.7502 18.375"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.5"
				d="M32.3261 54.2538L39.5597 61.4874C40.2411 62.1889 41.1946 62.625 42.25 62.625C44.3211 62.625 46 60.9459 46 58.875C46 57.8196 45.564 56.8661 44.8625 56.1847L29.6738 40.9961"
				stroke="#2E7FDB"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default BoostIcon;
